/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import { useForm } from 'react-hook-form';
import { Typography } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogStatus from 'layout/dialog/DialogStatus';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import { useTranslation } from 'react-i18next';
import Button from '../../../../components/common/Button';
import { CustomSelectBox } from '../../../../components/common/CustomSelectBox';
import { useUserAccounts } from '../../../../redux/features/user/userAccounts/useUserAccounts';
import { getOtherOrganizations } from '../../../../redux/features/organization/organization.helpers';

function TransferSubmissionDialog({ transferDialog }) {
  const { t } = useTranslation();
  const { user } = useUserAccounts();

  const { control, formState, watch } = useForm({
    mode: 'onChange',
    defaultValues: { destOrganization: transferDialog.selectedOrg },
  });
  const selectedOrg = watch('destOrganization', '');

  return (
    <>
      <Dialog open={transferDialog.isOpen} fullWidth maxWidth="md">
        <DialogTitle>
          <DialogStatus variant="warning" />
          <Typography component="h2" variant="h2" gutterBottom>
            {t('actions.submission.transfer.title')}
          </Typography>
        </DialogTitle>
        <DialogContent>
          {t('actions.submission.transfer.description')}
          <p>{t('actions.submission.transfer.select.organization')}</p>
          <CustomSelectBox
            id="destOrganizationId"
            name="destOrganization"
            control={control}
            itemId="id"
            itemLabel="name"
            items={getOtherOrganizations(user)}
            label={t('actions.submission.transfer.select.default')}
            defaultValue=""
            validationRules={{ required: true }}
          />
        </DialogContent>
        <DialogActions>
          <Button data-testid="cancel" color="default" onClick={transferDialog.close}>
            {t('actions.cancel')}
          </Button>
          <Button
            id="transfer"
            color="primary"
            onClick={transferDialog.confirm(transferDialog.values, selectedOrg)}
            disabled={!formState?.isValid}
          >
            {t('actions.submission.transfer.button')}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default TransferSubmissionDialog;
